import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { Logger } from '../Logger.service';
import { SrdUser } from '../models/srd-user';


@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  private user: SrdUser;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient, private logger: Logger) {}

  /** GET users from the server */
  getSrdUsers(): Observable<SrdUser[]> {
    return this.http
      // .get<SrdUser[]>(
      //   'http://localhost:8080/api/v1/getSrdUsers'
      // )
      .get<SrdUser[]>(
        'https://srd-soft-tech.azurewebsites.net/api/v1/getSrdUsers'
      )
      .pipe(catchError(this.handleError<SrdUser[]>('getSrdUsers: ', [])));
  }

  /** Register/Add user to the server */
  registerNewUser(user: SrdUser): Observable<SrdUser> {
    return this.http
    // .post<SrdUser>(
    //     'http://localhost:8080/api/v1/registerUser/sendEmail',
      .post<SrdUser>(
        'https://srd-soft-tech.azurewebsites.net/api/v1/registerUser/sendEmail',
        user,
        this.httpOptions
      )
      .pipe(catchError(this.handleError<SrdUser>('registerNewUser: ', user)));
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
